import { FAULT_ATTEND_KEYS } from '../../constants/protocol';

/** `fault_type` for POST and GET /attends; '' for a fault it doesn't know. */
export const faultAttendKey = (faultType) => FAULT_ATTEND_KEYS[faultType] ?? '';

/** SSR and thermocouple faults are logged per number on ESS/TES; everything else is index 0. */
export const faultAttendIndex = (deviceType, faultType, faultNumber) =>
  deviceType === 'tgs'
    ? 0
    : faultType?.includes('ssr') || faultType?.includes('thermocouple')
    ? faultNumber
    : 0;

/**
 * Body for POST /attends.
 * @typedef {Object} AttendPayload
 * @property {string} user_name
 * @property {string} fault_type  a FAULT_ATTEND_KEYS value
 * @property {string} action_taken
 * @property {number} fault_index
 * @property {string} device_id  device MAC
 * @property {'ESS'|'TGS'|'TES'} device_type
 */

/** @returns {AttendPayload} */
export const attendPayload = ({
  userName,
  faultType,
  actionTaken,
  faultNumber,
  machine,
  deviceType,
}) => ({
  user_name: userName,
  fault_type: faultAttendKey(faultType),
  action_taken: actionTaken,
  fault_index: faultAttendIndex(deviceType, faultType, faultNumber),
  device_id: machine,
  device_type: deviceType.toUpperCase(),
});
